import { axiosInstance } from "../../utility/apiInstance";
import {
    ApiResponse,
    MilestoneGroup,
    MilestonePosition,
    ShipmentMode,
} from "./grouping-milestone";

const MANUAL_ENDPOINT: Record<ShipmentMode, string> = {
    Air: "/api/v1/awb-manual-milestone",
    Ocean: "/api/v1/ocean-manual-milestone",
};

/** Fetch all groupings, optionally filtered by search text. */
export const getGroupings = async (search: string): Promise<MilestoneGroup[]> => {
    const { data } = await axiosInstance.get<ApiResponse>(
        `api/v1/groupingMileStone?search=${search}`
    );
    return data.data;
};

/** Toggle a grouping's active status. */
export const toggleGroupingActive = async (id: string, isActive: boolean) => {
    const { data } = await axiosInstance.put(`api/v1/groupingMileStone/${id}`, {
        isActive,
    });
    return data;
};

/** Fetch manual milestones for a given mode (Air/Ocean) and position (first/last). */
export const getManualMilestones = async (
    mode: ShipmentMode,
    position: MilestonePosition
) => {
    const res = await axiosInstance.get(MANUAL_ENDPOINT[mode], {
        params: { type: position },
    });
    return res?.data?.data || [];
};

/** Create a new grouping, or update an existing one when editingId is provided. */
export const saveGrouping = async (payload: any, editingId: string | null) => {
    const apiUrl =
        editingId != null
            ? `/api/v1/groupingMileStone/updatestatus/${editingId}`
            : "/api/v1/groupingMileStone";
    const { data } = await axiosInstance.post(apiUrl, payload);
    return data;
};